import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { vehiculeService } from '../../services/vehiculeService';
import { BoitierStatus } from '../../types';

interface BoitierStatusState {
  byImei: Record<string, BoitierStatus>;
  loadingByImei: Record<string, boolean>;
  errorByImei: Record<string, string | null>;
}

const initialState: BoitierStatusState = {
  byImei: {},
  loadingByImei: {},
  errorByImei: {},
};

export const fetchBoitierStatus = createAsyncThunk<BoitierStatus, string>(
  'boitierStatus/fetch',
  (imei) => vehiculeService.getBoitierStatus(imei.trim())
);

const boitierStatusSlice = createSlice({
  name: 'boitierStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBoitierStatus.pending, (state, action) => {
        const imei = action.meta.arg.trim();
        state.loadingByImei[imei] = true;
        state.errorByImei[imei] = null;
      })
      .addCase(fetchBoitierStatus.fulfilled, (state, action: PayloadAction<BoitierStatus, string, { arg: string }>) => {
        const requestedImei = action.meta.arg.trim();
        state.loadingByImei[requestedImei] = false;
        state.errorByImei[requestedImei] = null;
        state.byImei[requestedImei] = action.payload;
        state.byImei[action.payload.imei] = action.payload;
      })
      .addCase(fetchBoitierStatus.rejected, (state, action) => {
        const imei = action.meta.arg.trim();
        state.loadingByImei[imei] = false;
        state.errorByImei[imei] = action.error.message ?? 'Erreur de chargement du statut boitier';
      });
  },
});

export default boitierStatusSlice.reducer;
